import React from 'react';
import { IMPACT_LABELS } from '../format';

const ReasonsList = ({ report }) => (
  <ol className="grid gap-6 md:grid-cols-2">
    {report.reasons.map((reason, i) => (
      <li key={i} className="rp-keep flex flex-col rounded-[24px] bg-[var(--lp-surface)] p-6 sm:p-8">
        <div className="flex flex-wrap items-center gap-2">
          <span className="rounded-full border border-[var(--lp-line)] px-2.5 py-0.5 text-xs font-semibold">
            {IMPACT_LABELS[reason.impact]}
          </span>
          {reason.competitor && (
            <span className="rounded-full border border-[var(--lp-line)] px-2.5 py-0.5 text-xs text-[var(--lp-muted)]">
              {reason.competitor}
            </span>
          )}
        </div>
        <h3 className="mt-5 text-2xl font-semibold leading-tight tracking-[-0.02em]">{reason.title}</h3>
        <p className="mt-3 leading-relaxed text-[var(--lp-muted)]">{reason.explanation}</p>
        <div className="mt-6 border-t border-[var(--lp-line)] pt-5">
          <p className="lp-kicker">Pruebas</p>
          <ul className="mt-3 space-y-2">
            {reason.evidence.map((item, j) => (
              <li key={j} className="border-l-2 border-[var(--lp-lime)] pl-3 text-sm leading-relaxed">
                {item}
              </li>
            ))}
          </ul>
        </div>
      </li>
    ))}
  </ol>
);

export default ReasonsList;
